<template>
  <section>
    <div class="row mb-2">
      <div class="col-md-7">
        <button class="btn btn-primary btn-sm" @click="add">Add</button>
      </div>
      <div class="col-md-3 custom-weight-total">
        <div
          :class="{
            'custom-weight-notok': weightTotal !== 100,
            'custom-weight-ok': weightTotal === 100,
          }"
        >
          {{ weightTotal }}%
        </div>
        <div class="custom-total-label">(total score weight)</div>
      </div>
      <div class="col-md-2"></div>
    </div>
    <div class="list-group custom-components">
      <div
        v-for="(item, idx) of subchallenges"
        :key="idx"
        class="list-group-item list-group-item-action"
      >
        <div class="row custom-group">
          <div class="col-md-7 custom-name">
            <img
              :src="item.sub_challenge.icon"
              :class="{
                'custom-icon-background': item.sub_challenge.isSetBackground,
              }"
            />
            <h5>{{ item.sub_challenge.name }}</h5>
          </div>
          <div class="col-md-3 text-center">
            <input
              v-if="item.showPercent"
              type="Number"
              v-model="item.weight"
              @change="balanceWeights(item)"
              placeholder="weight"
              class="custom-score-weight"
            />
          </div>
          <div class="col-md-2">
            <small>{{ item.sub_challenge.subtitle }}</small>
            <button class="btn btn-link custom-remove" @click="remove(item.id)">
              <i class="far fa-trash-alt"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <component-add
    :show="actionAddComponent"
    @close="closeModal"
    @save="saveComponent"
  />
  <confirm-remove
    :show="actionConfirmRemove"
    :confirmTitle="confirmTitleRemove"
    :confirmAction="confirmActionRemove"
    :confirmQuestion="confirmQuestionRemove"
    @closing="closeModal"
    @proceed="performRemove"
  />
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ConfirmRemove from '@/Components/ZElements/ConfirmDialog'
import ComponentAdd from './component-add'
export default {
  name: 'challenge-components',
  components: {
    ConfirmRemove,
    ComponentAdd,
  },
  data() {
    return {
      itemId: null,
      confirmTitleRemove: 'Confirm Removal',
      confirmActionRemove: 'Remove',
      confirmQuestionRemove: 'Are you sure you wish to remove this Component?',
      actionConfirmRemove: null,
      actionAddComponent: null,
    }
  },
  emits: ['saveIt'],
  mounted() {
    this.itemId = null
  },
  computed: {
    ...mapGetters('challenges', ['challenge', 'ruletypes', 'weightTotal']),
    subchallenges() {
      let _data = []
      if (this.challenge) {
        console.log('SubChallenges - Challenge', this.challenge)
        if (this.challenge.sub_challenges) {
          _data = JSON.parse(JSON.stringify(this.challenge.sub_challenges))
          _data.forEach((element) => {
            if (element.sub_challenge.rule.substring(0, 10) === 'dashboard_') {
              element.sub_challenge.icon =
                '/media/challenges/ic_videos_32dp.png'
            }
            if (element.sub_challenge.rule === 'NutritionHabits') {
              let found = this.ruletypes.find(
                (x) => x.name === 'Nutrition Habits'
              )
              if (found) {
                element.sub_challenge.icon = found.icon
                element.isSetBackground = true
              }
            }
            element.showPercent = true
            switch (element.sub_challenge.rule) {
              case 'ProgressPhotos':
              case 'BodyFatLoss':
              case 'Measurements':
              case 'WeightLoss':
                element.showPercent = false
                break
            }
          })
        }
      }
      console.log('Component (Subchallenges)', _data)
      return _data
    },
  },
  methods: {
    ...mapActions('challenges', ['setChallengeData']),
    balanceWeights(item) {
      let data = {
        name: 'weight',
        value: null,
      }
      if (item) {
        data.value = {
          id: item.id,
          weight:
            item.weight !== null && item.weight !== ''
              ? parseInt(item.weight)
              : 0,
        }
      }
      this.setChallengeData(data)
      this.$emit('saveIt', false)
      if (this.weightTotal === 100) {
        this.$emit('saveIt', true)
      }
    },
    add() {
      this.actionAddComponent = true
    },
    saveComponent(data) {
      this.setChallengeData({
        name: 'add-component',
        value: data,
      })
      this.$emit('saveIt', false)
      if (this.weightTotal === 100) {
        this.$emit('saveIt', true)
      }
      this.actionAddComponent = null
    },
    closeModal() {
      this.actionConfirmRemove = null
      this.actionAddComponent = null
    },
    remove(id) {
      this.itemId = id
      this.actionConfirmRemove = true
    },
    performRemove() {
      this.setChallengeData({
        name: 'remove-component',
        value: this.itemId,
      })
      this.$emit('saveIt')
      this.actionConfirmRemove = null
      this.itemId = null
      this.balanceWeights()
    },
    setRule(item) {
      let results = ''
      console.log('Set Rule', item)
      return results
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-components {
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 370px;
}
.custom-group {
  position: relative;
  .custom-name {
    display: inline-flex;
    img {
      width: 48px;
      height: 48px;
      margin-right: 20px;
    }
    h5 {
      padding-top: 10px;
    }
  }
  small {
    right: 30px;
    position: absolute;
    bottom: 0;
  }
}
.custom-weight-notok {
  color: red;
}
.custom-weight-ok {
  color: green;
}
.custom-weight-total {
  text-align: center;
  padding-right: 40px;
  div {
    width: 100%;
  }
  .custom-total-label {
    font-size: 0.8em;
  }
}
.custom-score-weight {
  width: 80px;
  text-align: right;
  margin-top: 10px;
}
.custom-remove {
  position: absolute;
  top: -8px;
  right: -5px;
  color: red;
}
.custom-icon-background {
  background-color: rgba(0, 0, 0, 0.2);
  padding: 5px;
  border-radius: 5px;
  text-align: center;
}
</style>
